import moment from "moment";

export default {
  methods: {
    $formatDateTime(date) {
      return moment(date).format("DD.MM.YYYY - HH:mm");
    },
    $formatDate(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    $formatForQuery(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
